"use client";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useWebsiteData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";
import { Typography } from "@/components/Typography";
import { WebsiteSocialSection } from "./components/WebsiteSocialSection";

import {
  PreviewCloudinaryImage,
  PreviewPrimaryAction,
} from "@/features/previews/shared/components";

import "./WebsiteTemplate.scss";

export const WebsiteTemplate = (props: QRProps<"website">) => {
  const { isInitialPreview, data } = useWebsiteData(props);

  if (!data) {
    return null;
  }

  const { companyName, logoUrl, title, subtitle, buttonText, buttonUrl, themeColor } = data;

  const hasLogo = Boolean(logoUrl);

  return (
    <PhoneLayout
      page="website"
      dataQA="preview-website-container"
      backgroundColor={themeColor?.backgroundColor || "white"}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div className="website-template">
        {companyName && (
          <div className="website-template__company-name">
            <Typography
              Tag="p"
              classname="u-bold"
              size="s"
            >
              {companyName}
            </Typography>
          </div>
        )}

        <div className="website-template__body">
          {hasLogo && (
            <div className="website-template__logo-container">
              <PreviewCloudinaryImage
                src={logoUrl}
                alt="Company logo"
                variant="hero"
                isInitPreview={isInitialPreview}
                className="website-template__logo-image"
                placeholderClass="website-logo--background"
              />
            </div>
          )}

          <div className="website-template__divider-bottom">
            <div
              className={`website-template__qr-content ${hasLogo ? "website-template__qr-content--has-logo" : ""}`}
            >
              {title && (
                <div className="website-template__title">
                  <Typography
                    Tag="p"
                    size="l"
                    classname="u-bold u-spacing-4"
                  >
                    {title}
                  </Typography>
                </div>
              )}

              {subtitle && (
                <div className="website-template__subtitle">
                  <Typography
                    Tag="p"
                    size="s"
                    classname="u-spacing-5"
                  >
                    {subtitle}
                  </Typography>
                </div>
              )}

              {buttonText && (
                <div className="website-template__primary-button">
                  <PreviewPrimaryAction
                    text={buttonText}
                    url={buttonUrl}
                    buttonColor={themeColor?.buttonColor}
                    className="u-spacing-5 website-button"
                  />
                </div>
              )}

              <WebsiteSocialSection
                data={data}
                isInitialPreview={isInitialPreview}
              />
            </div>
          </div>
        </div>
      </div>
    </PhoneLayout>
  );
};
